jQuery = window.$ = window.jQuery = require('jquery');
require('bootstrap3');
require('autogrow');

window.dayjs       = require('dayjs');
var advancedFormat = require('dayjs/plugin/advancedFormat'); // .format('Do X')
var weekday        = require('dayjs/plugin/weekday');
var utc            = require('dayjs/plugin/utc'); // Required by Timezone plugin
var timezone       = require('dayjs/plugin/timezone');
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(utc);
dayjs.extend(timezone);

require('json3');
require('jquery-form');
require('select2');
require('jquery-validation');
require('lodash');
require('jquery-slimscroll');
require('jquery-ui/ui/widgets/sortable');
window.filesize = require('filesize').filesize;
require('../../../../node_modules/summernote/dist/summernote');
window.passwordStrength = require('../../../../node_modules/check-password-strength');
require('bourbon-neat');
datetimepicker = window.datetimepicker = require('../../../../node_modules/jquery-datetimepicker/build/jquery.datetimepicker.full.min');
